var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticClass:"p-0",attrs:{"size":"small","title":"活跃度统计曲线"}},[_c('div',{staticClass:"area-chart"},[_c('e-chart',{attrs:{"options":_vm.options,"autoresize":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }